import { File } from 'src/store/models/channel/index.js'
import native from 'src/config/native.js'

const fileMixin = {
  data: () => ({
    fileTypes: {
      image: ['jpg', 'jpeg', 'png', 'heic', 'bmp', 'gif', 'tif', 'tiff', 'webp', 'eps', 'svg'],
      sheet: ['xls', 'xlsx', 'ods', 'numbers', 'csv', 'xlsm'],
      music: ['mp3', 'm4a', 'wav', 'wma', 'amr', 'flac', 'alac', 'opus', 'aac', 'aiff', 'ogg'],
      video: ['mp4', 'mov', 'avi', 'm4v', 'wmv', '3gp', 'mkv', 'mpg', 'webm', 'heif', 'flv', '3gpp'],
      pdf: ['pdf'],
      text: ['rtf', 'txt', 'html'],
      archive: ['zip', 'rar', '7z'],
      slide: ['ppt', 'pptx', 'odp', 'key', 'ppsx', 'pptm', 'flipchart', 'pps'],
      doc: ['pages', 'doc', 'docx', 'odt', 'docm', 'dotx', 'epub', 'pub']
    }
  }),
  methods: {
    /**
     * Return file icon name based on extension
     * @param  {Object} target file object, should have .extension property
     * @return {String} appropriate icon name based on file type
     */
    getFileIconName (file) {
      if (!file?.extension) return 'other'

      const iconName = Object.keys(this.fileTypes).find(s => this.fileTypes[s].find(ex => ex === file.extension.toLowerCase()))
      return iconName || 'other'
    },

    /**
     * Return full path to icon image
     * @param  {String} name of the icon
     * @return {String} full path to icon
     */
    getIconImage (iconName) {
      return `${import.meta.env.BASE_URL}icons/attachment/${iconName}.svg`
    },

    /**
     * Resolve correct icon for file and return full path to icon
     * @param  {Object} file object with .extension property
     * @return {String} Full path till icon image
     */
    getIconImageByFile (file) {
      const iconName = this.getFileIconName(file)
      return this.getIconImage(iconName)
    },

    async fetchSingleFile () {
      const { uuid, cloud_id, source_id, id } = this.file
      return File.getDetails(uuid, cloud_id, id, source_id)
    },

    async createDownloadElement () {
      const { meta: { download_uri: download, uri } } = await this.fetchSingleFile()
      const element = document.createElement('A')
      const isPDF = this.file?.extension === 'pdf'
      const targetUrl = isPDF ? uri : download

      element.href = targetUrl
      element.target = isPDF ? '_blank' : '_self'
      element.download = download.substr(download.lastIndexOf('/') + 1)

      return { element, targetUrl }
    },

    async beforeDownload () {
      const { element, targetUrl } = await this.createDownloadElement()
      document.body.appendChild(element)

      // if we click this in a cypress test a browser window will appear which cant be closed with our current cy version
      // and following tests may break
      if (!window.Cypress) {
        // ensure we use the in-app browser on native devices, for capacitor app-version
        if (await native.isCapacitorSupported()) {
          await native.openUrlInAppBrowser(targetUrl)
        } else {
          // Add this timeout to fix open new tab in ios safari browser and ios native app
          setTimeout(() => { element.click() }, 0)
        }
      }

      document.body.removeChild(element)
      this.showOptionsModal = false
    },

    async handleDownload (vueWaitOptions) {
      try {
        this.$wait.start(vueWaitOptions)
        await this.beforeDownload()
      } finally {
        this.$wait.end(vueWaitOptions)
      }
    }
  }
}

export default fileMixin
